const denimSizes = ["23", "24", "25", "26", "27", "28", "29", "30", "31", "32"];
const alphaSizes = ["XS", "S", "M", "L", "XL"];

const productData = [
  {
    id: 1,
    name: "LARK FLARE JEAN — ARCHIVE BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 66,
    image: "/img/catalog-01.png",
    images: ["/img/catalog-01.png"],
    size: denimSizes,
    colors: ["Archive Blue"],
    material: "100% organic cotton denim",
    description: "A high-rise jean with an elongated flare, cut in structured denim with a softly worn archive-blue finish. The fitted waist and thigh open gradually below the knee for a balanced full-length line, while classic five-pocket construction keeps the shape practical for everyday wear.",
    attributes: { fit: "High rise / flare", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "foundation", "organic cotton"],
    Features: ["Rigid organic denim", "Five-pocket construction", "Zip fly and metal button", "Wash at 30°C inside out"],
    featured: true,
    stock: 6,
  },
  {
    id: 2,
    name: "VALE ZIP STRAIGHT JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 88,
    image: "/img/safe-product-02.jpg",
    images: ["/img/safe-product-02.jpg"],
    size: denimSizes,
    colors: ["Coal Wash"],
    material: "98% cotton, 2% recycled elastane",
    description: "Relaxed straight denim in a charcoal coal wash, detailed with a discreet functional zip at each ankle. The mid-rise waist sits cleanly without feeling rigid, and the softened cotton blend gives the leg enough ease for daily movement while preserving a structured silhouette.",
    attributes: { fit: "Mid rise / straight", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "black", "zip detail"],
    Features: ["Soft washed handle", "Functional ankle zips", "Relaxed straight leg", "Low-impact finishing"],
    featured: true,
    stock: 4,
  },
  {
    id: 3,
    name: "HALO WIDE FLARE JEAN — MINERAL BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 106,
    image: "/img/safe-product-03.jpg",
    images: ["/img/safe-product-03.jpg"],
    size: denimSizes,
    colors: ["Mineral Blue"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "Sculpted high-rise jeans with a sweeping wide flare and a layered mineral-blue wash. Recycled and organic cotton fibres create a substantial hand feel, while carefully placed fading adds depth without distracting from the long, clean proportion of the leg.",
    attributes: { fit: "High rise / wide flare", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "statement wash", "recycled cotton"],
    Features: ["Circular cotton blend", "Hand-finished wash variation", "Full-length leg", "Leather-free back patch"],
    featured: false,
    stock: 8,
  },
  {
    id: 4,
    name: "COVE BARREL JEAN — MIST BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 82,
    image: "/img/safe-product-04.jpg",
    images: ["/img/safe-product-04.jpg"],
    size: denimSizes,
    colors: ["Mist Blue"],
    material: "100% organic cotton denim",
    description: "A low-rise barrel jean shaped with curved side seams and finished in pale mist blue. The leg has controlled volume through the thigh before tapering softly at the ankle, creating an easy sculptural shape that works with fitted tops, shirts and relaxed layers.",
    attributes: { fit: "Low rise / barrel", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "barrel leg", "mist blue"],
    Features: ["Curved side seam", "Low-slung waist", "Rigid organic denim", "Tonal tobacco stitching"],
    featured: false,
    stock: 3,
  },
  {
    id: 5,
    name: "ELOWEN WIDE-LEG JEAN — SKY FADE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 98,
    image: "/img/safe-product-05.jpg",
    images: ["/img/safe-product-05.jpg"],
    size: denimSizes,
    colors: ["Sky Fade"],
    material: "100% cotton denim",
    description: "An elongated wide-leg silhouette with a precise mid rise and an airy sky-faded blue tone. The rigid denim settles into the body with wear, while a clean hem and classic five-pocket layout make the generous proportion straightforward to style throughout the week.",
    attributes: { fit: "Mid rise / wide leg", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "wide leg", "essential"],
    Features: ["Long fluid proportion", "Clean hem", "Garment-washed finish", "Classic five pockets"],
    featured: false,
    stock: 7,
  },
  {
    id: 6,
    name: "NOCTURNE ZIP LEATHER TROUSER — BLACK",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 184,
    image: "/img/safe-product-06.jpg",
    images: ["/img/safe-product-06.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Responsibly sourced lamb leather",
    description: "Supple black leather trousers with a relaxed straight cut and restrained ankle hardware. A smooth partial lining supports comfortable movement, while the clean mid-rise waist and subtle zip openings let the leg fall straight or open slightly over footwear.",
    attributes: { fit: "Mid rise / straight", lining: "Viscose twill", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "leather", "black", "tailoring"],
    Features: ["Soft lamb leather", "Ankle zip opening", "Partially lined", "Professional leather clean only"],
    featured: true,
    stock: 2,
  },
  {
    id: 7,
    name: "SIENNA FLARE LEATHER TROUSER — CARAMEL",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 175,
    image: "/img/safe-product-07.jpg",
    images: ["/img/safe-product-07.jpg"],
    size: alphaSizes,
    colors: ["Caramel"],
    material: "Silky nappa leather",
    description: "Fluid nappa leather trousers in warm caramel, balancing a clean tailored waist with an easy flare. The pressed front crease gives definition through the leg, and the lightweight lining helps the soft leather move smoothly without adding unnecessary bulk.",
    attributes: { fit: "High rise / flare", lining: "Cupro blend", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "leather", "brown", "flare"],
    Features: ["Lightweight nappa", "Pressed front crease", "Concealed fastening", "Specialist clean only"],
    featured: false,
    stock: 4,
  },
  {
    id: 8,
    name: "ROWEN UTILITY DENIM JUMPSUIT — CHARCOAL",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 134,
    image: "/img/safe-product-08.jpg",
    images: ["/img/safe-product-08.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A charcoal denim jumpsuit with a defined belted waist, practical pockets and a generous straight leg. The relaxed upper body layers comfortably over a light base, while the removable self belt allows the silhouette to be worn shaped or loose according to the day.",
    attributes: { fit: "Relaxed / belted", pockets: "Six pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "jumpsuit", "denim", "vintage black"],
    Features: ["Removable self belt", "Concealed front zip", "Workwear pockets", "Garment-dyed finish"],
    featured: true,
    stock: 3,
  },
  {
    id: 9,
    name: "SOLACE LEATHER OVERSHIRT — COGNAC",
    category: "Tops / Jackets",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 200,
    image: "/img/safe-product-09.jpg",
    images: ["/img/safe-product-09.jpg"],
    size: alphaSizes,
    colors: ["Cognac"],
    material: "Silky nappa leather",
    description: "An oversized cognac leather overshirt with soft shoulders, a curved hem and pared-back utility pockets. The lightweight nappa construction is designed for flexible layering, with a roomy body that sits easily over knitwear while retaining the familiar line of a button-front shirt.",
    attributes: { fit: "Oversized", closure: "Press studs", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "shirt", "leather", "layering"],
    Features: ["Featherweight nappa", "Dropped shoulders", "Curved shirt hem", "Specialist clean only"],
    featured: false,
    stock: 2,
  },
  {
    id: 10,
    name: "MERIDIAN STRAIGHT JEAN — HERITAGE BLUE",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 69,
    image: "/img/safe-product-10.jpg",
    images: ["/img/safe-product-10.jpg"],
    size: denimSizes,
    colors: ["Heritage Blue"],
    material: "100% organic cotton denim",
    description: "A balanced straight jean with a regular rise and an understated heritage-blue wash. Mid-weight organic denim provides dependable structure without excessive stiffness, and the full-length leg is proportioned to work neatly with both low-profile shoes and heavier everyday footwear.",
    attributes: { fit: "Mid rise / straight", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "classic", "heritage blue"],
    Features: ["12.5 oz denim", "Straight full-length leg", "Antique metal trims", "Plastic-free brand patch"],
    featured: false,
    stock: 10,
  },
  {
    id: 11,
    name: "ROSETTE LOOSE JEAN — PLUM CHARCOAL",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 92,
    image: "/img/safe-product-11.jpg",
    images: ["/img/safe-product-11.jpg"],
    size: denimSizes,
    colors: ["Plum Charcoal"],
    material: "100% cotton denim",
    description: "Loose low-rise denim in charcoal with a quiet plum undertone and a broken-in handle. The generous leg falls from a relaxed waist for an unfussy shape, while low-impact pigment washing creates subtle tonal variation that becomes more personal with repeated wear.",
    attributes: { fit: "Low rise / loose", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "denim", "washed black", "loose fit"],
    Features: ["Low-impact pigment wash", "Loose leg", "Soft broken-in handle", "Contrast inner binding"],
    featured: false,
    stock: 5,
  },
  {
    id: 12,
    name: "COLUMN DENIM SKIRT — CHARCOAL",
    category: "Denim Pants",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 75,
    image: "/img/safe-product-12.jpg",
    images: ["/img/safe-product-12.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A long charcoal denim skirt with a clean column line and a practical front walking split. The high-rise five-pocket construction feels familiar and secure, while the washed black surface and reinforced hem give the maxi length enough structure for regular day-to-evening wear.",
    attributes: { fit: "High rise / column", length: "Maxi", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "skirt", "denim", "black"],
    Features: ["Front walking split", "Five-pocket styling", "Washed black finish", "Reinforced hem"],
    featured: false,
    stock: 6,
  },
  {
    id: 13,
    name: "ARC PANELLED LEATHER SKIRT — BLACK",
    category: "Leather",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 165,
    image: "/img/safe-product-13.jpg",
    images: ["/img/safe-product-13.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Silky nappa leather",
    description: "A fluid black leather midi skirt defined by curved panel seams and a restrained natural sheen. The high-rise waist opens into a gentle A-line shape, and a lightweight lining allows the supple panels to move cleanly while keeping the overall finish polished and uncomplicated.",
    attributes: { fit: "High rise / A-line", length: "Midi", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "skirt", "leather", "black"],
    Features: ["Supple paneled nappa", "Concealed side zip", "Lightweight lining", "Specialist clean only"],
    featured: false,
    stock: 2,
  },
  {
    id: 14,
    name: "FRAME LEATHER MINI DRESS — BLACK",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 192,
    image: "/img/safe-product-14.jpg",
    images: ["/img/safe-product-14.jpg"],
    size: alphaSizes,
    colors: ["Black"],
    material: "Silky nappa leather",
    description: "A clean-lined black leather mini dress with a softened square neckline and a gently shaped waist. Panelled construction gives definition without heavy embellishment, while the full lining and concealed back zip support a smooth fit that can be worn alone or over a fine base layer.",
    attributes: { fit: "Slim / mini", closure: "Back zip", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "dress", "leather", "evening"],
    Features: ["Panelled construction", "Fully lined", "Hidden back zip", "Specialist clean only"],
    featured: true,
    stock: 2,
  },
  {
    id: 15,
    name: "CAMBER RELAXED JEAN — MID BLUE",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 99,
    image: "/img/safe-product-15.jpg",
    images: ["/img/safe-product-15.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Mid Blue"],
    material: "100% organic cotton denim",
    description: "Relaxed straight jeans in mid blue, cut with an easy waist and a generous full-length break. Rigid organic denim gives the shape substance and softens gradually with wear, while a roomy seat and classic five-pocket construction make the pair dependable for everyday rotation.",
    attributes: { fit: "Relaxed / straight", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim", "mid blue", "relaxed"],
    Features: ["Organic rigid denim", "Relaxed seat", "Full-length inseam", "Low-impact wash"],
    featured: true,
    stock: 9,
  },
  {
    id: 16,
    name: "NORTH DOUBLE-FACE CHECK SHIRT — INK CHECK",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 89,
    image: "/img/safe-product-16.jpg",
    images: ["/img/safe-product-16.jpg"],
    size: alphaSizes,
    colors: ["Ink Check"],
    material: "Organic cotton flannel",
    description: "A relaxed double-face shirt combining ink blue, charcoal and softly brushed organic cotton. The oversized body provides room for layering, while a chest patch pocket, curved hem and balanced check scale keep the piece useful as either a shirt or a light overshirt.",
    attributes: { fit: "Oversized", closure: "Button front", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "shirt", "check", "organic cotton"],
    Features: ["Double-face construction", "Brushed organic cotton", "Chest patch pocket", "Curved hem"],
    featured: false,
    stock: 5,
  },
  {
    id: 17,
    name: "REED TAPERED JEAN — HERITAGE BLUE",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 72,
    image: "/img/safe-product-17.jpg",
    images: ["/img/safe-product-17.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Heritage Blue"],
    material: "100% cotton denim",
    description: "An everyday jean with a regular rise, a softly tapered leg and a balanced heritage-blue finish. Mid-weight cotton denim holds a clean line through the thigh before narrowing toward the hem, offering an easy alternative to both slim and wide silhouettes.",
    attributes: { fit: "Regular / tapered", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim", "classic", "tapered"],
    Features: ["Mid-weight denim", "Regular waist", "Tapered hem", "Antique silver hardware"],
    featured: false,
    stock: 12,
  },
  {
    id: 18,
    name: "HEARTH OVERSIZED SWEATSHIRT — UMBER",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 50,
    image: "/img/safe-product-18.jpg",
    images: ["/img/safe-product-18.jpg"],
    size: alphaSizes,
    colors: ["Umber"],
    material: "Organic cotton loopback jersey",
    description: "An oversized umber sweatshirt with dropped shoulders and a substantial dry-touch cotton surface. Heavyweight loopback jersey gives the body a structured drape, while deep ribbed trims and a clean crew neckline make it comfortable enough for daily layering without appearing overly casual.",
    attributes: { fit: "Oversized", neckline: "Crew", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "sweatshirt", "brown", "organic cotton"],
    Features: ["Heavyweight loopback", "Garment-dyed color", "Ribbed trims", "Dropped shoulder"],
    featured: false,
    stock: 7,
  },
  {
    id: 19,
    name: "DOCK DENIM OVERSHIRT — DEEP INDIGO",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 120,
    image: "/img/safe-product-19.jpg",
    images: ["/img/safe-product-19.jpg"],
    size: alphaSizes,
    colors: ["Deep Indigo"],
    material: "100% organic cotton denim",
    description: "An easy deep-indigo denim overshirt with useful chest pockets and softly rounded volume. Reinforced yoke construction supports repeated wear, while the relaxed cut and press-stud front allow it to function as a substantial shirt indoors or a light jacket between seasons.",
    attributes: { fit: "Relaxed", closure: "Metal press studs", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim shirt", "indigo", "layering"],
    Features: ["Two utility chest pockets", "Indigo garment wash", "Reinforced yoke", "Wear as shirt or jacket"],
    featured: true,
    stock: 6,
  },
  {
    id: 20,
    name: "DRIFT STRAIGHT SWEATPANT — UMBER",
    category: "Trousers",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 54,
    image: "/img/safe-product-20.jpg",
    images: ["/img/safe-product-20.jpg"],
    size: alphaSizes,
    colors: ["Umber"],
    material: "Organic cotton loopback jersey",
    description: "Relaxed umber sweatpants with an open straight hem and a clean everyday sportswear finish. Heavyweight loopback cotton gives the leg an intentional drape, while an internal drawcord and discreet side-seam pockets keep the elasticated waist practical and visually uncluttered.",
    attributes: { fit: "Relaxed / straight", waist: "Elasticated", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "trousers", "jersey", "brown"],
    Features: ["Heavyweight loopback", "Internal drawcord", "Side seam pockets", "Open straight hem"],
    featured: false,
    stock: 8,
  },
  {
    id: 21,
    name: "FOUNDRY BOX DENIM JACKET — CHARCOAL",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 127,
    image: "/img/safe-product-21.jpg",
    images: ["/img/safe-product-21.jpg"],
    size: alphaSizes,
    colors: ["Charcoal"],
    material: "100% cotton denim",
    description: "A compact charcoal denim jacket with a boxy line, dropped shoulders and strong workwear seams. Four external pockets and adjustable back tabs add practical detail, while the cropped proportion sits neatly over high-rise trousers and longer layers without feeling restrictive.",
    attributes: { fit: "Boxy / cropped", closure: "Metal buttons", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "jacket", "denim", "vintage black"],
    Features: ["Washed black denim", "Adjustable back tabs", "Four external pockets", "Reinforced topstitching"],
    featured: true,
    stock: 4,
  },
  {
    id: 22,
    name: "RANGE WIDE JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 80,
    image: "/img/safe-product-22.jpg",
    images: ["/img/safe-product-22.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Coal Wash"],
    material: "100% cotton denim",
    description: "Wide-leg coal denim with a relaxed low waist and subtle fading along the seams. The full-length leg maintains generous volume from hip to hem, while sturdy cotton denim and pronounced topstitching give the washed black finish a durable, grounded character.",
    attributes: { fit: "Low rise / wide", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim", "wide leg", "black"],
    Features: ["Wide full-length leg", "Garment-washed black", "Relaxed waist", "Heavy tobacco stitching"],
    featured: false,
    stock: 7,
  },
  {
    id: 23,
    name: "CAMBER RELAXED JEAN — COAL WASH",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 94,
    image: "/img/safe-product-23.jpg",
    images: ["/img/safe-product-23.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Coal Wash"],
    material: "100% organic cotton denim",
    description: "A relaxed straight jean in a soft charcoal coal wash, finished with a full-length inseam. Organic cotton denim provides a firm but wearable handle, and the roomy seat transitions into a consistent leg width for an uncomplicated silhouette that suits regular use.",
    attributes: { fit: "Relaxed / straight", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim", "straight", "black"],
    Features: ["Organic cotton denim", "Relaxed seat", "Vintage stone wash", "Full-length inseam"],
    featured: false,
    stock: 9,
  },
  {
    id: 24,
    name: "BOROUGH LOOSE JEAN — DEEP INDIGO",
    category: "Denim Pants",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 114,
    image: "/img/safe-product-24.jpg",
    images: ["/img/safe-product-24.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Deep Indigo"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "A fluid loose jean with a generous leg, relaxed waistband and deep-indigo character. The organic and recycled cotton blend gives the denim a substantial yet broken-in feel, with enough room through the seat and thigh for comfort across long days.",
    attributes: { fit: "Relaxed / boyfriend", pockets: "Five pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "denim", "loose fit", "deep indigo"],
    Features: ["Circular cotton blend", "Loose leg", "Relaxed waistband", "Deep indigo wash"],
    featured: true,
    stock: 5,
  },
  {
    id: 25,
    name: "FALLOW DENIM CHORE JACKET — ECRU",
    category: "Tops / Jackets",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 117,
    image: "/img/product-25.jpg",
    images: ["/img/product-25.jpg"],
    size: alphaSizes,
    colors: ["Ecru"],
    material: "100% organic cotton denim",
    description: "A softly structured ecru denim chore jacket with an easy shoulder and three useful patch pockets. The unbleached organic cotton surface keeps a natural texture, while adjustable cuffs and a relaxed button front make the jacket adaptable across shirts, knitwear and light base layers.",
    attributes: { fit: "Relaxed", closure: "Corozo buttons", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "jacket", "denim", "ecru", "organic cotton"],
    Features: ["Unbleached organic denim", "Three patch pockets", "Adjustable button cuffs", "Wash at 30°C"],
    featured: true,
    stock: 8,
  },
  {
    id: 26,
    name: "GROVE PLEATED TROUSER — DARK OLIVE",
    category: "Trousers",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 64,
    image: "/img/product-26.jpg",
    images: ["/img/product-26.jpg"],
    size: alphaSizes,
    colors: ["Dark Olive"],
    material: "55% lyocell, 45% organic cotton",
    description: "A fluid dark-olive wide-leg trouser shaped with twin front pleats and a clean tailored waistband. The lyocell and organic cotton twill has a soft, cool drape, while four practical pockets and an internal waist tab support comfortable all-day wear.",
    attributes: { fit: "High rise / wide leg", pockets: "Four pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "trousers", "olive", "lyocell", "wide leg"],
    Features: ["Soft twill weave", "Twin front pleats", "Internal waist tab", "Cool gentle wash"],
    featured: false,
    stock: 11,
  },
  {
    id: 27,
    name: "TIDE DENIM MIDI DRESS — RINSE INDIGO",
    category: "Dresses / Jumpsuit",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 142,
    image: "/img/product-27.jpg",
    images: ["/img/product-27.jpg"],
    size: alphaSizes,
    colors: ["Rinse Indigo"],
    material: "80% organic cotton, 20% recycled cotton",
    description: "A sleeveless rinse-indigo denim midi dress with long vertical seams and a quietly generous silhouette. The straight relaxed body leaves space for movement and light layering, while side-seam pockets and a small back keyhole add function without interrupting the clean line.",
    attributes: { fit: "Straight / relaxed", length: "Midi", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "dress", "denim", "indigo", "recycled cotton"],
    Features: ["Circular cotton blend", "Side-seam pockets", "Back keyhole closure", "Wash inside out"],
    featured: true,
    stock: 7,
  },
  {
    id: 28,
    name: "EMBER RIB CARDIGAN — GRAPHITE",
    category: "Knitwear",
    department: "Woman",
    collection: "FOUNDATIONS 01 · WOMAN",
    price: 35,
    image: "/img/product-28.jpg",
    images: ["/img/product-28.jpg"],
    size: alphaSizes,
    colors: ["Graphite"],
    material: "70% traceable wool, 30% recycled cashmere",
    description: "A warm graphite rib cardigan with dropped shoulders, a soft V neckline and generous sleeves. The traceable wool and recycled cashmere blend feels substantial without excessive weight, and the relaxed button front works equally well closed as a knit top or open as a layer.",
    attributes: { fit: "Relaxed", closure: "Corozo buttons", dispatch: "Fulfilled from Hong Kong" },
    tags: ["woman", "cardigan", "knitwear", "graphite", "recycled cashmere"],
    Features: ["Responsible wool blend", "Chunky rib structure", "Dropped shoulder", "Hand wash cold"],
    featured: false,
    stock: 5,
  },
  {
    id: 29,
    name: "QUARRY FIELD JACKET — SAND",
    category: "Tops / Jackets",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 158,
    image: "/img/product-29.jpg",
    images: ["/img/product-29.jpg"],
    size: alphaSizes,
    colors: ["Sand"],
    material: "65% recycled cotton, 35% organic cotton",
    description: "A balanced sand-coloured field jacket with four low-profile pockets and a dry, garment-washed handle. The recycled and organic cotton canvas feels durable without being rigid, while an internal drawcord lets the regular, easy body be adjusted for a closer or more relaxed shape.",
    attributes: { fit: "Regular / easy", closure: "Corozo buttons", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "jacket", "sand", "utility", "recycled cotton"],
    Features: ["Recycled cotton canvas", "Four utility pockets", "Internal drawcord", "Garment washed"],
    featured: true,
    stock: 9,
  },
  {
    id: 30,
    name: "MEADOW RELAXED TROUSER — SAGE",
    category: "Trousers",
    department: "Man",
    collection: "FOUNDATIONS 01 · MAN",
    price: 60,
    image: "/img/product-30.jpg",
    images: ["/img/product-30.jpg"],
    size: ["28", "29", "30", "31", "32", "33", "34", "36"],
    colors: ["Sage"],
    material: "100% organic cotton twill",
    description: "Relaxed pleated trousers in brushed sage organic cotton twill, cut with room through the seat and leg. A single front pleat adds controlled volume, while the extended waist tab and four-pocket construction keep the soft straight silhouette refined enough for work or everyday wear.",
    attributes: { fit: "Relaxed / straight", pockets: "Four pockets", dispatch: "Fulfilled from Hong Kong" },
    tags: ["man", "trousers", "sage", "twill", "organic cotton"],
    Features: ["Brushed organic twill", "Single front pleat", "Extended waist tab", "Wash at 30°C"],
    featured: false,
    stock: 12,
  },
];

export default productData;
